import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../reducers';
import { Players } from '../../config/commonTypes';
import * as action from '../actions/players';

export const usePlayersState = () => {
  const { ...players } = useSelector((state: RootState) => state.players) as Players;
  const playersExcluded = useSelector((state: RootState) => state.players.playersExcluded);
  const playersExcludedByPeriod = useSelector((state: RootState) => state.players.playersExcludedByPeriod);
  return { ...players, excludedPlayers: playersExcluded, excludedPlayersByPeriod: playersExcludedByPeriod };
};

export const usePlayersDispatch = () => {
  const dispatch = useDispatch();
  return { ...bindActionCreators({ ...action }, dispatch) };
};